import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'

import { cn } from '@/lib/utils'

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-radius-xs border border-secondary-border shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-accent data-[state=checked]:border-accent data-[state=checked]:text-primary-foreground',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      <svg
        className='fill-accent-foreground'
        xmlns='http://www.w3.org/2000/svg'
        width='10'
        height='7'
        viewBox='0 0 10 7'
      >
        <path d='M9.89618 0.103818C10.0346 0.242242 10.0346 0.469971 9.89618 0.608395L3.8234 6.68118C3.68497 6.8196 3.45724 6.8196 3.31882 6.68118L0.103818 3.46618C-0.0346059 3.32775 -0.0346059 3.10002 0.103818 2.9616C0.242242 2.82317 0.469971 2.82317 0.608395 2.9616L3.57111 5.92431L9.39161 0.103818C9.53003 -0.0346059 9.75776 -0.0346059 9.89618 0.103818Z' />
      </svg>
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
